export default "__VITE_ASSET__CsWdR3aK__"